import React from 'react';
import classNames from 'classnames';

import styles from './Evelyn.module.scss';

// will likely need a better quality (square) image
import evelyn from '../../public/images/evelyn.png';

const {
  evelyn: evelynClass,
  'evelyn-image': evelynImageClass,
  'speech-bubbles-container': speechBubblesContainerClass,
  'speech-bubble': speechBubbleClass,
  'align-bubbles': alignBubblesClass
} = styles;

const Evelyn = ({
  customClass = '',
  image = evelyn,
  speechBubbleArray = [
    {
      style: 'header',
      content: "Hi! I'm Evelyn."
    },
    'Welcome to Everdays.'
  ],
  alignBubbles = false
}) => {
  const speechBubblesContainerClasses = classNames(speechBubblesContainerClass, {
    [alignBubblesClass]: alignBubbles
  });
  return (
    <div className={`${evelynClass} ${customClass}`}>
      <div className={speechBubblesContainerClasses}>
        {speechBubbleArray.map((bubble, idx) => (
          <div key={idx}>
            {idx === 0 && (
              <div className={evelynImageClass} style={{ backgroundImage: `url('${image}')` }} />
            )}
            <div className={speechBubbleClass}>
              {bubble?.style === 'header' ? (
                <h2>{bubble.content}</h2>
              ) : (
                <p>{bubble?.content || bubble}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Evelyn;
